import { Loader } from '@piggytechng/component-library';
import useUSDRequest from '../../hooks/useUSDRequest';

const USDComments = () => {
  const { singleUSDRequest, isLoadingSingleUSDRequests } = useUSDRequest();

  // Parse and sort status history
  const getSortedStatusHistory = () => {
    if (!singleUSDRequest?.statusHistory) return [];

    try {
      const history = JSON.parse(singleUSDRequest.statusHistory);
      if (!Array.isArray(history)) return [];

      // Sort by dateReturned if available, otherwise by date (most recent first)
      return history.sort((a, b) => {
        const dateA = a.dateReturned || a.date || 0;
        const dateB = b.dateReturned || b.date || 0;
        return dateB - dateA;
      });
    } catch (error) {
      console.error('Error parsing status history:', error);
      return [];
    }
  };

  const sortedHistory = getSortedStatusHistory();

  return (
    <>
      {isLoadingSingleUSDRequests ? (
        <div className="page-loader">
          <Loader color="#0F60D6" />
        </div>
      ) : (
        <>
          {sortedHistory.length > 0 ? (
            <div className="usd-details--comments">
              {sortedHistory.map((item, index) => (
                <div key={index}>
                  <div className="info-containter flex--4">
                    <h1>Reason for Being Rejected</h1>
                    <textarea
                      value={item?.reason || 'Others'}
                      disabled
                      style={{
                        marginBottom: '20px',
                        backgroundColor: '#F9FAFB',
                        border: 'none',
                        height: 'fit-content',
                        whiteSpace: 'wrap',
                      }}
                    />

                    <h1>Comments</h1>
                    <textarea
                      value={item?.comment || 'None'}
                      disabled
                      style={{
                        marginBottom: '20px',
                        backgroundColor: '#F9FAFB',
                        border: 'none',
                        height: 'fit-content',
                        whiteSpace: 'wrap',
                      }}
                    />
                  </div>
                  {index !== sortedHistory.length - 1 && (
                    <div
                      style={{
                        borderBottom: '1px solid #E5E7EB',
                        margin: '30px 0',
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className="usd-details--comments">
              <div className="info-containter flex--4">
                <h1>Reason for Being Rejected</h1>
                <textarea
                  value={'Others'}
                  disabled
                  style={{
                    marginBottom: '20px',
                    backgroundColor: '#F9FAFB',
                    border: 'none',
                    height: 'fit-content',
                    whiteSpace: 'wrap',
                  }}
                />

                <h1>Comments</h1>
                <textarea
                  value={'None'}
                  disabled
                  style={{
                    marginBottom: '20px',
                    backgroundColor: '#F9FAFB',
                    border: 'none',
                    height: 'fit-content',
                    whiteSpace: 'wrap',
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default USDComments;
